import { configureStore } from '@reduxjs/toolkit'
import { payments, whiteLabel, companyConfig } from 'reducers'

const store = configureStore({
  reducer: {
    payments,
    whiteLabel,
    companyConfig,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default function createStore() {
  return store
}
